import ua from 'universal-analytics';
import axios from 'axios';
import { EtvConfig } from '@/interfaces/player-config.interface';

export enum eventType {
  LIVE = 'LIVE',
  CLIP = 'CLIP',
}

class StatisticService {
  private reporting: any;

  private analytics: any;
  private location: any = undefined;

  private gaInitialized: boolean = false;
  private reInitialized: boolean = false;

  /**
   * Add Google Analytics support to player
   * https://develop.earthtv.com/jira/browse/WV-9
   * https://www.npmjs.com/package/universal-analytics
   * @param token
   */
  public initGoogleAnalytics(token: string, config: EtvConfig) {
    this.gaInitialized = true;

    if (config.source) {
      this.location = config.source.alias ? config.source.alias : config.source.id;
    }

    this.analytics = ua(token);
    this.analytics.set('anonymizeIp', true);
    this.analytics.pageview('/').send();
  }

  public initReporting() {
    this.reInitialized = true;
  }

  public updateConfig(config: EtvConfig) {
    if (config.source) {
      this.location = config.source.alias ? config.source.alias : config.source.id;
    }
  }

  /**
   * eventActions:
   *
   * Video Initial Play:  First time the user cklicks on the play button
   * Video Play:          User clicks on the play button
   * Video Start:         The video starts to play
   * Video Pause:         User clicks the pause button
   * Video Completed:     Stream end event
   *
   * PrerollAdX Start:    Preroll start event
   * PrerollAdX Ad Start: Preroll starts to play
   * Ad endet:            Ad end event
   * PrerollAdX Completed: end of preroll
   *
   *
   * @param {*} eventAction
   * @param {*} category
   */
  public ga(eventAction: string, type: string) {
    if (!this.gaInitialized) {
      return;
    }

    let eventCategory = 'video';
    if (type === eventType.LIVE) {
      eventCategory = 'livecam';
    }

    // ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue], [fieldsObject]);
    // visitor.event("Event Category", "Event Action").send()
    if (this.location) {
      this.analytics.event(eventCategory, eventAction, this.location).send();
    } else {
      this.analytics.event(eventCategory, eventAction).send();
    }
  }

  public report(eventAction: string, streamUrl: any) {
    if (!this.reInitialized) {
      return;
    }

    // var skip = true;

    // if(app.reporting || config.reporting) {
    //     skip = false;
    // }

    const TOKEN = streamUrl.split('token=').pop();
    const urlParts = streamUrl.split('/');

    let APPLICATION = urlParts[3];
    let STERAM = urlParts[4];
    //  check edge or cdnedge
    if (streamUrl.indexOf('out-stream.earthtv.com') < 0) {
      APPLICATION = urlParts[4];
      STERAM = urlParts[5];
    }

    const ev = {
      token: TOKEN,
      application: APPLICATION,
      referrer: document.referrer,
      stream: STERAM,
      event: eventAction,
    };

    const evString = JSON.stringify(ev);

    axios
      .post(process.env.VUE_APP_REPORTING_PATH as string, evString)
      .then((response) => {
        // console.log('response', response);
      })
      .catch((error) => {
        // console.log('response', error);
      });
  }
}

export const statisticService = new StatisticService();
